import fetchApi from "../fetchApi";
import {DEFAULT_LIMIT} from "../../contstants";

export const GetSellOrdersShiftReport = async (
    {
        limit = DEFAULT_LIMIT,
        offset = 0,
        type = "",
        office_id="",
        dateFrom="",
        dateTo="",
        id = "",
        user="",
        prn="",
        corporate_customer_id="",
        details=false
    }
   ) => {

    const options = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/sell-order/shift-report?prn=${prn}&limit=${limit}&offset=${offset}&office_id=${office_id}&created_on_gte=${dateFrom}&created_on_lte=${dateTo}&ids=${id}&type=${type}&created_by=${user}&corporate_customer_id=${corporate_customer_id}${details ? '&details=true' : ''}`, options);
};